import { tqc } from '../../system';
import { __DEV__ } from '../../utils';
/**
 * A flexible flex spacer that expands along the major axis of its containing flex layout.
 * It renders a `div` by default, and takes up any available space.
 */
export var Spacer = tqc('div', {
  baseStyle: {
    flex: 1,
    justifySelf: 'stretch',
    alignSelf: 'stretch'
  }
});
if (__DEV__) {
  Spacer.displayName = 'Spacer';
}